import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const YandexBrandAltSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M14.7972 3.97432H13.0859C9.94865 3.97432 8.29851 5.56335 8.29851 7.90614C8.29851 10.5545 9.43935 11.7954 11.7821 13.3862L13.7175 14.69L8.15591 23H4L8.99116 15.566C6.12055 13.5085 4.5093 11.5101 4.5093 8.13023C4.5093 3.89284 7.46326 1 13.0656 1H18.6272V22.9796H14.7972V3.97432Z", fill: "white" }) }));
const YandexBrandAltSize24 = hoc(forwardRef(YandexBrandAltSize24Component), 'YandexBrandAltSize24');

export { YandexBrandAltSize24 as default };
//# sourceMappingURL=YandexBrandAltSize24.js.map
